import { render, staticRenderFns } from "./DetailsGrid.vue?vue&type=template&id=4b17ba5e&"
import script from "./DetailsGrid.vue?vue&type=script&lang=js&"
export * from "./DetailsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports